import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { MultipleErrorToast } from '../utils/Utils';
import QuillRichTextEditor from '../common/QuillRichTextEditor';

const useStyles = makeStyles(() => ({
  templates: {
    height: '60vh',
    width: '97%',
    background: '#f3f4f7',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
}));

export default function ContentFrom({ handleChangeForm, handleBack, setContentsList, editData, clearState }) {
  const classes = useStyles();

  const INITIAL_CONTENT_FORM = {
    overview: '',
    duration: '',
  };
  const [contentForm, setContentForm] = useState(INITIAL_CONTENT_FORM);

  useEffect(() => {
    if (editData) {
      setContentForm(editData);
    }
  }, []);

  const handleValidation = () => {
    let isCorrect = true;
    const errors = [];

    if (!contentForm.overview) {
      isCorrect = false;
      errors.push('Please enter a overview');
    }
    if (!contentForm.duration) {
      isCorrect = false;
      errors.push('Please enter duration.');
    }
    if (contentForm.duration && Number.isNaN(Number(contentForm.duration))) {
      isCorrect = false;
      errors.push('Please enter a number for duration.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isCorrect;
  };

  const handleContentSave = () => {
    if (!handleValidation('content')) return;
    const contentData = {
      duration: contentForm.duration,
      overview: contentForm.overview,
    };
    setContentsList([contentData]);
    clearState();
  };

  return (
    <>
      <Grid className={classes.templates}>
        <Typography variant="h6">Add Content</Typography>
        <Grid>
          <Typography className={classes.required_field}>Video Overview </Typography>
          <Grid item style={{ marginTop: '5px' }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item style={{ width: '94%' }}>
                <QuillRichTextEditor
                  value={contentForm.overview}
                  changeFn={(e) =>
                    setContentForm({
                      ...contentForm,
                      overview: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Duration (in seconds) </Typography>
          <input
            placeholder="Enter duration here"
            className={classes.inputField}
            value={contentForm.duration}
            onChange={(e) => handleChangeForm(e, 'duration', contentForm, setContentForm)}
          />
        </Grid>
      </Grid>
      <Grid style={{ display: 'flex' }}>
        <Button onClick={handleBack} variant="outlined">
          Back
        </Button>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <Button variant="contained" color="primary" onClick={handleContentSave}>
            Continue
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
